export default function ($routeSegmentProvider) {

  "ngInject";

  $routeSegmentProvider
    .when('/service-provider/verification/type', 'service-provider.select-type')
    .when('/service-provider/verification/individual', 'service-provider.individual-verification')
    .when('/service-provider/verification/bicycle-shop', 'service-provider.bicycle-shop-verification')
    .when('/service-provider/verification/mobile-shop', 'service-provider.mobile-shop-verification')
    .when('/service-provider/verification/redirect', 'service-provider.redirect-verification')

    .within('service-provider')

    .segment('select-type', {
      access: {requireLogin: true, hasAuthority: 'MECHANIC'},
      breadcrumb: [{
        label: 'service_provider.breadcrumb.select_verification_type'
      }],
      template: '<service-provider-select-type-page></service-provider-select-type-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "service-provider-select-type.module" */ "./select-type/service-provider-select-type.module");
      }
    })

    .segment('individual-verification', {
      access: {requireLogin: true, hasAuthority: 'MECHANIC'},
      breadcrumb: [{
        label: 'service_provider.breadcrumb.individual_service_provider_verification'
      }],
      template: '<service-provider-individual-verification-page></service-provider-individual-verification-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "service-provider-individual-verification.module" */ "./individual/service-provider-individual-verification.module");
      }
    })

    .segment('bicycle-shop-verification', {
      access: {requireLogin: true, hasAuthority: 'MECHANIC'},
      breadcrumb: [{
        label: 'service_provider.breadcrumb.bicycle_shop_verification'
      }],
      template: '<service-provider-bicycle-shop-verification-page></service-provider-bicycle-shop-verification-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "service-provider-bicycle-shop-verification.module" */ "./bicycle-shop/service-provider-bicycle-shop-verification.module");
      }
    })

    .segment('mobile-shop-verification', {
      access: {requireLogin: true, hasAuthority: 'MECHANIC'},
      breadcrumb: [{
        label: 'service_provider.breadcrumb.mobile_shop_verification'
      }],
      template: '<service-provider-mobile-shop-verification-page></service-provider-mobile-shop-verification-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "service-provider-mobile-shop-verification.module" */ "./mobile-shop/service-provider-mobile-shop-verification.module");
      }
    })

    .segment('redirect-verification', {
      access: {requireLogin: true, hasAuthority: 'MECHANIC'},
      breadcrumb: [{
        label: ''
      }],
      template: '<service-provider-verification-redirect-page></service-provider-verification-redirect-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "service-provider-verification-redirect.module" */ "./redirect/service-provider-verification-redirect.module");
      }
    });
}
